import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Reveal, { EASE } from "./Reveal";
import { Plus } from "lucide-react";

const faqs = [
  {
    q: "Quel profil recherche Alternativ ?",
    a: "Des entrepreneurs dans l'âme : commerciaux voulant évoluer, profils en reconversion professionnelle ou experts de l'énergie. Aucun diplôme spécifique n'est exigé — c'est ton tempérament de bâtisseur qui compte, sur notre cœur de marché : le B2C.",
  },
  {
    q: "Quel apport financier est nécessaire ?",
    a: "Le modèle a été conçu pour rester accessible : pas de redevance d'entrée démesurée ni de loyer commercial. Les détails chiffrés exacts figurent dans le dossier de candidature.",
  },
  {
    q: "La formation est-elle vraiment assurée ?",
    a: "Oui. Parcours de formation initial, accompagnement terrain pendant tes 6 premiers mois, puis formation continue sur les produits énergie et les techniques de vente B2C.",
  },
  {
    q: "Qu'est-ce que l'exclusivité géographique ?",
    a: "Ton territoire t'est contractuellement réservé : aucun autre manager Alternativ ne peut y ouvrir d'agence. C'est la garantie que ton travail de prospection te revient intégralement.",
  },
  {
    q: "Combien puis-je espérer gagner ?",
    a: "Tes revenus proviennent de commissions directes élevées sur chaque contrat signé par tes vendeurs, en B2C comme en B2B. Utilise le simulateur plus haut pour une projection — le dossier détaille le modèle complet.",
  },
];

function Item({ faq, open, onToggle, index }) {
  return (
    <div data-testid={`faq-item-${index}`} className="border-b border-emerald-400/10">
      <button
        onClick={onToggle}
        data-testid={`faq-trigger-${index}`}
        className="w-full flex items-center justify-between gap-6 py-6 text-left group"
        aria-expanded={open}
      >
        <span className={`font-display font-semibold text-lg md:text-xl transition-colors duration-300 ${open ? "text-emerald-300" : "text-slate-100 group-hover:text-emerald-200"}`}>
          {faq.q}
        </span>
        <motion.span
          animate={{ rotate: open ? 45 : 0 }}
          transition={{ duration: 0.4, ease: EASE }}
          className={`shrink-0 w-9 h-9 rounded-full border grid place-items-center transition-colors duration-300 ${open ? "border-emerald-400/60 text-emerald-300" : "border-emerald-400/20 text-slate-400"}`}
        >
          <Plus className="w-4 h-4" />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: EASE }}
            className="overflow-hidden"
          >
            <p className="pb-7 pr-16 text-sm md:text-base text-slate-400 leading-relaxed max-w-3xl">{faq.a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="relative py-28 md:py-36 border-t border-emerald-400/10">
      <div className="max-w-4xl mx-auto px-6">
        <Reveal className="mb-14">
          <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-emerald-400 mb-6">06 — Les questions</p>
          <h2 className="font-display font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            Ce que tu te demandes
            <span className="text-emerald-400"> déjà.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border-t border-emerald-400/10">
            {faqs.map((f, i) => (
              <Item key={i} faq={f} index={i} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
